export const OcrFormat = {
    truckstop_board: "truckstop_board",
    truckstop_detail: "truckstop_detail",
    bennett: "bennett",
    bme: "bme",
    trinity: "trinity",
    evans: "evans",
    landstar: "landstar",
    ratecon: "ratecon",
    fuel_board: "fuel_board",
    unknown: "unknown",
};
//# sourceMappingURL=types.js.map